import { defaultLosJsonHeaders } from 'api/requestHeaders'
import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../../integrations/datadog/OctaneLogger'

export default async function validateEmail(value: string) {
    try {
        const { data } = await axios.post(
            `${config.API_BASE_URL}/api/v3/utils/value-formats/email/validate/`,
            {
                value,
            },
            {
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to validate email: ${axiosError.message}`,
            axiosError,
        )

        throw new Error(axiosError.message)
    }
}
